import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const FaceBook: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17.497" height="36" viewBox="0 0 17.497 36">
            <path
                id="facebook"
                d="M4.467,36V19.108H0V13.026H4.467v-5.2C4.467,3.749,7.105,0,13.185,0a36.913,36.913,0,0,1,4.281.236l-.143,5.68S15.467,5.9,13.441,5.9c-2.192,0-2.544,1.01-2.544,2.687v4.441h6.6l-.287,6.082H10.9V36H4.467"
                fill="#fff"
            />
        </svg>
    );
};

export default React.memo(FaceBook);
